import { memo } from 'react'
import { createPortal } from 'react-dom'
import { AnimatePresence } from 'framer-motion'

import { MOBILE_TAB_BAR_HEIGHT } from 'consts'
import { MOTION } from 'styles/consts'
import * as Styled from './styled'
import { IProps } from './types'

const NO_ANIMATION = { duration: 0, ease: 'easeInOut' as const }

const SlideUp = ({
  isOpen,
  className,
  children,
  onClose,
  isHidden = false,
  // Default: clear the mobile bottom tool bar. Pass 0 for a drawer that should
  // run to the viewport bottom instead.
  bottomMargin = MOBILE_TAB_BAR_HEIGHT,
  disableAnimation,
  zIndex,
  minHeight,
  maxHeight
}: IProps) => {
  return (
    document.body &&
    createPortal(
      <AnimatePresence>
        {isOpen && (
          <>
            <Styled.GlobalScrollBlock />
            <Styled.Container className={className} $zIndex={zIndex}>
              <Styled.BackdropOverlay onClick={onClose} />
              <Styled.Content
                data-slide-up-content=""
                initial={{ opacity: 0, y: 50 }}
                animate={
                  isHidden ? { opacity: 0, y: 50 } : { opacity: 1, y: 0 }
                }
                exit={{ opacity: 0, y: 50 }}
                transition={
                  disableAnimation
                    ? NO_ANIMATION
                    : {
                        duration: MOTION.duration.slow,
                        ease: MOTION.ease.drawer
                      }
                }
                $bottomMargin={bottomMargin}
                $minHeight={minHeight}
                $maxHeight={maxHeight}
              >
                <Styled.CloseLine onClick={onClose} />
                {children}
              </Styled.Content>
            </Styled.Container>
          </>
        )}
      </AnimatePresence>,
      document.body
    )
  )
}

export default memo(SlideUp)
